import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFacebook, faInstagram } from "@fortawesome/free-brands-svg-icons";
import { faPaw } from "@fortawesome/free-solid-svg-icons";
import "./Footer.css";

function Footer() {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <h3>
              <FontAwesomeIcon icon={faPaw} className="paw-icon" />
              Baby Zoo Garden
            </h3>
            <p>Kreativnost i zabava za djecu</p>
          </div>
          <div className="footer-section">
            <h3>Kontakt</h3>
            <a href="tel:+385993152678" className="footer-link">
              +385 99 3152 678
            </a>
            <a href="mailto:marina@babyzoogarden.com" className="footer-link">
              marina@babyzoogarden.com
            </a>
          </div>
          <div className="footer-section">
            <h3>Pratite nas</h3>
            <div className="social-icons">
              <a
                href="https://www.facebook.com/babyzoogarden"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Facebook"
              >
                <FontAwesomeIcon icon={faFacebook} />
              </a>
              <a
                href="https://www.instagram.com/babyzoogarden"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram"
              >
                <FontAwesomeIcon icon={faInstagram} />
              </a>
            </div>
          </div>
        </div>
        <div className="footer-bottom">
          <p>© 2025 Baby Zoo Garden</p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
